@if (constant) {
  <div class="lock-indicator">
    @if (locked) {
      <i (click)="lockClicked()" class="fa fa-lock lock-indicator-icon"
      [style.cursor]="can_unlock ? 'pointer' : 'default'"></i>
    }
    @if (isConstant(constant) && !invalid) {
      <constant-field
        [tooltip]="stringValue(constant.value)"
        [constant_property]="constant_property"
        [constant_value]="constant.value"
        [constant]="constant"
        [auto_class]="auto_class"
        [formats]="formats"
        (constant_changed)="constantChanged($event);"
        (change_complete)="changeComplete($event);"
        [show_sig]="show_sig"
        [defaultValue]="defaultValue"
        [disabled]="isDisabled">
      </constant-field>
    }
    @if (invalid) {
      <div class="invalid-field">
        <div>
          <i [matTooltip]="'This property is not relevant to this item.'" class="fa fa-info-circle"></i>&nbsp;Invalid
          property
        </div>
      </div>
    }
  </div>
}
